import React from "react";

import Manu2 from "./Menu/Manu2";

const Layout = ({ children }) => {
  return (
    <div>
      <Manu2 />
      <main style={{ min: "80vh" }}>{children}</main>
    </div>
  );
};

export default Layout;
